import React from "react";
import { useNavigate } from "react-router-dom";
import "./values.css";
import { GoGlobe } from "react-icons/go";
import { FaHandsHelping } from "react-icons/fa";
import { GiFreedomDove } from "react-icons/gi";
import { AiTwotoneFlag } from "react-icons/ai";
import { VscGraphLine } from "react-icons/vsc";
import { IoMdSchool } from "react-icons/io";
const Values = (props) => {
  const navigate = useNavigate();
  const t = props.language;

  return (
    <div className="values--main">
      <div className="text__team" style={{ color: "black" }}>
        {t("our_values")}
        <span className="line__team"></span>
      </div>
      <div className="team__desc--wrap">
        <p className="team__desc" style={{ marginTop: "1rem" }}>
          {t("value_desc")}
        </p>
      </div>
      <div className="value--main">
        <div>
          <GoGlobe className="about__us--icons" />
          <h1>{t("values_1")}</h1>
        </div>
        <div>
          <FaHandsHelping className="about__us--icons" />
          <h1>{t("values_3")}</h1>
        </div>
        <div>
          <GiFreedomDove className="about__us--icons" />
          <h1>{t("values_2")}</h1>
        </div>
        <div>
          <IoMdSchool className="about__us--icons" />
          <h1>{t("values_4")}</h1>
        </div>
        <div>
          <AiTwotoneFlag className="about__us--icons" />
          <h1>{t("values_5")}</h1>
        </div>
        <div>
          <VscGraphLine className="about__us--icons" />
          <h1>{t("values_1-1")}</h1>
        </div>
      </div>
      <button
        className="invest-btn vl"
        style={{ color: "black" }}
        onClick={() => {
          navigate("/our-values");
        }}
      >
        {t("dm")}
      </button>
    </div>
  );
};

export default Values;
